module.exports = __webpack_public_path__ + "img/packshots-tablet_old.3f0f229b.png";